import React from "react";

import { Route, NavLink, Switch } from "react-router-dom";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import { Section } from "components/Section.js";
import Overview from "./ApiSections/Overview.js";
import { Authentication } from "./ApiSections/Authentication.js";
import References from "./ApiSections/References";

import { Container } from "@mui/material";
import { useStyles } from "./ApiStyles";

const topics = {
  adjustment: "Adjustment",
  build: "Build",
  customer: "Customer",
  estimate: "Estimate",
  invoice: "Invoice",
  item: "Item",
  itemreceipt: "ItemReceipt",
  job: "Job",
  lot: "Lot",
  pickticket: "PickTicket",
  process: "Process",
  purchaseorder: "PurchaseOrder",
  rental: "Rental",
  rentalreturn: "RentalReturn",
  return: "Return",
  returntovendor: "ReturnToVendor",
  rma: "Rma",
  salesorder: "SalesOrder",
  salesreceipt: "SalesReceipt",
  serialnumber: "SerialNumber",
  shipment: "Shipment",
  transfer: "Transfer",
  vendor: "Vendor",
  workorder: "WorkOrder",
};

function ApiDoc() {
  return (
    <Container maxWidth="xl">
      <ApiDocHeader />
      <ApiContent />
    </Container>
  );
}

function ApiDocHeader() {
  return (
    <GridContainer>
      <GridItem md={3} />
      <GridItem md={9}>
        <h1 style={{ marginLeft: "20px" }}>API Documentation</h1>
      </GridItem>
    </GridContainer>
  );
}

function ApiContent() {
  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={3} className={classes.index}>
        <ApiIndex />
      </GridItem>
      <GridItem xs={9}>
        <GridContainer spacing={0} className={classes.apiDocs}>
          <ApiBody />
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
}

function ApiIndex() {
  const entries = Object.keys(topics).map((key) => (
    <IndexEntry
      friendlyName={PascalToFriendly(topics[key])}
      topic={key}
      moduleName={topics[key]}
      key={key}
    />
  ));

  return (
    <React.Fragment>
      <IndexEntry
        friendlyName="Overview"
        topic="overview"
        moduleName="Overview"
        key="overview"
      />
      <IndexEntry
        friendlyName="Authentication"
        topic="authentication"
        moduleName="Authentication"
        key="authentication"
      />
      <div>{entries}</div>
      <IndexEntry
        friendlyName="References"
        topic="references"
        moduleName="References"
        key="references"
      />
    </React.Fragment>
  );
}

function IndexEntry(props) {
  const { topic, moduleName, friendlyName } = props;
  return (
    <div style={{ textAlign: "right", marginBottom: "0.75em" }}>
      <NavLink to={"/apidoc/" + moduleName} activeClassName="current">
        {friendlyName}
      </NavLink>
      {(topic === "authentication" || topic === "workorder") && (
        <div style={{ margin: 0, height: "1.0em" }}>&nbsp;</div>
      )}
    </div>
  );
}

function ApiBody() {
  return (
    <div style={{ marginTop: "-0.85em", width: "100%" }}>
      <Switch>
        <Route path="/apidoc/overview" component={Overview} />
        <Route path="/apidoc/authentication" component={Authentication} />
        <Route path="/apidoc/References" component={References} />
        <Route path="/apidoc/:section" component={Section} />
        <Route>
          <Overview />
        </Route>
      </Switch>
    </div>
  );
}

function PascalToFriendly(pascal) {
  const friendly = pascal.replace(/([A-Z])/g, " $1").substr(1);
  return friendly
    .toLowerCase()
    .replace(/[a-z]/i, function (letter) {
      return letter.toUpperCase();
    })
    .trim();
}

export default ApiDoc;
